<template>
  <!--begin::Navbar-->
  <div class="app-navbar flex-shrink-0">
    <div id="kt_header_user_menu_toggle" class="app-navbar-item ms-1 ms-md-3">
      <!--begin::Menu wrapper-->
      <div
        class="cursor-pointer symbol symbol-30px symbol-md-40px"
        data-kt-menu-trigger="click"
        data-kt-menu-attach="parent"
        data-kt-menu-placement="bottom-end"
      >
        <span class="bg-light-danger text-danger symbol-label fw-bold">
            {{ currentUser?.name?.substring(0, 1) + currentUser?.surname?.substring(0, 1) }}
        </span>
      </div>
      <LUserMenu />
      <!--end::Menu wrapper-->
    </div>
  </div>
  <!--end::Navbar-->
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { getAssetPath } from 'assets/theme/metronic/ts/helpers/assets';
import LNotificationMenu from '@/components/theme/metronic/layout/header/navbar/menus/NotificationsMenu.vue';
import LQuickLinksMenu from '@/components/theme/metronic/layout/header/navbar/menus/QuickLinksMenu.vue';
import LUserMenu from '@/components/theme/metronic/layout/header/navbar/menus/UserAccountMenu.vue';
import {useAuthStore} from "~/stores/auth";
import {storeToRefs} from "pinia";

export default defineComponent({
  name: 'ThemeHeaderNavbar',
  components: {
    LNotificationMenu,
    LQuickLinksMenu,
    LUserMenu,
  },
  setup() {
    const store = useAuthStore();
    const { currentUser } = storeToRefs(store);

    return {
      currentUser,
      getAssetPath
    };
  }
});
</script>
